import { WebMixerService } from '@linktivity/triplabo-taxfree';
import config, { sessionConfig } from '../config';

const orderApi = new WebMixerService.OrderApi(config);
const paymentApi = new WebMixerService.PaymentApi(config);
const uploadApi = new WebMixerService.UploadApi(config);

const passportApi = new WebMixerService.AccountApi(sessionConfig);
const passportOcrApi = new WebMixerService.OCRApi(sessionConfig);
const passportUploadApi = new WebMixerService.UploadApi(sessionConfig);

export {
  orderApi,
  passportApi,
  passportOcrApi,
  passportUploadApi,
  paymentApi,
  uploadApi
};
